<template>
  <div class="RateTable">
    <SelectBox
      id="SelectRate"
      placeholder="Taksit Seçeneğini Giriniz"
      :value="value ? value.nofInst : null"
      @input="onChange"
      :options="options"
    />
    <div class="TableHeader">
      <table>
        <thead>
          <tr>
            <th>Taksit</th>
            <th>Aylık Tutar</th>
            <th>Toplam</th>
          </tr>
        </thead>
      </table>
    </div>
    <div class="TableBody">
      <table>
        <tbody>
          <tr v-for="item in rates" :key="item.nofInst" :id="`Rate${item.nofInst}`" @click="onClick(item)">
            <td>
              <div class="d-flex a-center">
                <Checkbox :id="`Checkbox${item.nofInst}`" :value="value && value.nofInst === item.nofInst" />
                {{item.expInst }}
              </div>
            </td>
            <td class="text-center">{{formatAmount(item.amountInst)}} TL</td>
            <td class="text-center">{{formatAmount(item.tAmount)}} TL</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import GeneralUtil from "../../util/generalUtil"
import {mapActions,mapGetters} from "vuex"

export default {
  name: "RateTable",
  components: {
    Checkbox: () => import("../Checkbox"),
    SelectBox: () => import("../SelectBox")
  },
  props: {
    value: {
      required: true
    }
  },
  data: () => ({
    rates:[] /*[
      { id: 1, period: 1, month: 120.9, total: 120.9 },
      { id: 2, period: 2, month: 60.45, total: 120.9 },
      { id: 3, period: 3, month: 40.3, total: 120.9 }
    ]*/
  }),
  computed: {
    ...mapGetters({
      selectedCard:'getSelectedCard'
    }),
    options() {
        if(this.selectedCard==null ) {
          return;
        }else if (this.selectedCard.installmentList==null){
          return;
        } else if(this.selectedCard.installmentList!=null && this.selectedCard.installmentList.length===1){
          let installment = this.selectedCard.installmentList[0];
          this.setSelectedInstallment(installment)
          this.$emit("input", installment);
        }
        this.rates=this.selectedCard.installmentList;
        //console.log("RateTableOptions:",this.rates)
        return this.rates.map(x => ({
            value: x.nofInst,
            label: x.nofInst === 1 ? x.expInst : `${x.nofInst} x ${x.amountInst} TL`
        }));
    }
  },
  methods: {
    ...mapActions({
        setSelectedInstallment:'setSelectedInstallment'
    }),
    onClick(item) {
      //console.log("RateTable-onClick-item:",item);
      this.setSelectedInstallment(item)
      this.$emit("input", item);
    },
    onChange(e) {
      //console.log("RateTable-onChange-e:",e);
      //console.log("RateTable-rates:",this.rates);
      this.onClick(this.rates.find(x => x.nofInst === e));
    },
    formatAmount(val){
      return GeneralUtil.formatAmount(val);
    }
  }
};
</script>